export default __webpack_public_path__ + "static/round-6f795bfd28346a7800c15e42ff2f72c9.png";